<template>
  <div>
    <span>{{ sw }}x{{ sh }}</span>
    <div class="d-inline-block d-sm-none">@xs</div>
    <div class="d-none d-sm-inline-block d-md-none">@sm</div>
    <div class="d-none d-md-inline-block d-lg-none">@md</div>
    <div class="d-none d-lg-inline-block d-xl-none">@lg</div>
    <div class="d-none d-xl-inline-block">@xl</div>
  </div>  
</template>

<script>
export default {
  name: 'screensize',
  computed: {
    sw: function () {
      return window.screen.width
    },
    sh: function () {
      return window.screen.height
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/debug/ScreenSize.vue